import { motion } from "framer-motion";
import { ShoppingBag, Sun, Moon } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { id: "colgantes", label: "Colgantes" },
  { id: "mesa", label: "Mesa" },
  { id: "pie", label: "Pie" },
  { id: "pared", label: "Pared" },
];

export const Navbar = ({ cartCount, onCartOpen, onNavigate, onPromos, dark, onToggleTheme }) => (
  <motion.header
    initial={{ y: -70, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="sticky top-0 z-40 border-b border-stone-200/60 bg-[#FDFBF7]/75 backdrop-blur-xl dark:border-stone-800/60 dark:bg-[#0C0A09]/75"
  >
    {new Date() <= new Date("2026-11-30T23:59:59") && (
      <div data-testid="announcement-bar" className="bg-amber-500 py-1.5 text-center font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-stone-950">
        Envío gratis en todo México · solo hasta el 30 de noviembre
      </div>
    )}
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
      <a
        data-testid="brand-logo-link"
        href="#inicio"
        onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
        aria-label="hylasu — inicio"
      >
        <Logo />
      </a>
      <nav className="hidden items-center gap-8 md:flex">
        {LINKS.map((l) => (
          <button
            key={l.id}
            data-testid={`nav-link-${l.id}`}
            onClick={() => onNavigate(l.id)}
            className="group relative text-sm font-medium text-stone-600 transition-colors duration-300 hover:text-stone-900 dark:text-stone-300 dark:hover:text-white"
          >
            {l.label}
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-amber-600 transition-all duration-300 group-hover:w-full dark:bg-amber-400" />
          </button>
        ))}
        <button
          data-testid="nav-link-promociones"
          onClick={onPromos}
          className="group relative text-sm font-semibold text-amber-700 transition-colors duration-300 hover:text-amber-800 dark:text-amber-400 dark:hover:text-amber-300"
        >
          Promociones
          <span className="absolute -bottom-1 left-0 h-px w-full bg-amber-600 transition-all duration-300 dark:bg-amber-400" />
        </button>
      </nav>
      <div className="flex items-center gap-1">
        <button
          data-testid="theme-toggle-button"
          onClick={onToggleTheme}
          aria-label="Cambiar tema"
          className="rounded-full p-2.5 text-stone-600 transition-colors duration-300 hover:bg-stone-200/60 hover:text-stone-900 dark:text-stone-300 dark:hover:bg-stone-800/60 dark:hover:text-white"
        >
          {dark ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <button
          data-testid="cart-drawer-trigger"
          onClick={onCartOpen}
          aria-label="Abrir carrito"
          className="relative rounded-full p-2.5 text-stone-600 transition-colors duration-300 hover:bg-stone-200/60 hover:text-stone-900 dark:text-stone-300 dark:hover:bg-stone-800/60 dark:hover:text-white"
        >
          <ShoppingBag size={18} />
          {cartCount > 0 && (
            <motion.span
              key={cartCount}
              initial={{ scale: 0.4 }}
              animate={{ scale: 1 }}
              data-testid="cart-badge-count"
              className="absolute -right-0.5 -top-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-amber-600 font-mono text-[10px] font-medium text-white"
            >
              {cartCount}
            </motion.span>
          )}
        </button>
      </div>
    </div>
  </motion.header>
);
